import AuthLayout from '@/layouts/AuthLayout.vue';
import LoginView from '@/views/auth/LoginView.vue';
import LoginOtpView from '@/views/auth/LoginOtpView.vue';
import ForgotPasswordView from "@/views/auth/forgot_password/ForgotPasswordView.vue";
import ResetPasswordLinkSentView from "@/views/auth/forgot_password/ResetPasswordLinkSentView.vue";
import ResetPasswordView from "@/views/auth/forgot_password/ResetPasswordView.vue";
import ResetPasswordConfirmedView from "@/views/auth/forgot_password/ResetPasswordConfirmedView.vue";
import CreatePasswordView from '@/views/auth/create_password/CreatePasswordView.vue';
import CreatePasswordConfirmedView from '@/views/auth/create_password/CreatePasswordConfirmedView.vue';

export default [
  {
    path: '/login',
    component: LoginView,
    meta: {
      layout: AuthLayout,
      requiresAuth: false
    }
  },
  {
    path: '/login/otp',
    component: LoginOtpView,
    meta: {
      layout: AuthLayout,
      requiresAuth: false
    }
  },
  {
    path: '/forgot-password',
    component: ForgotPasswordView,
    meta: {
      layout: AuthLayout,
      requiresAuth: false
    }
  },
  {
    path: '/reset-password',
    component: ResetPasswordView,
    meta: {
      layout: AuthLayout,
      requiresAuth: false
    }
  },
  {
    path: '/reset-password-sent',
    component: ResetPasswordLinkSentView,
    meta: {
      layout: AuthLayout,
      requiresAuth: false
    }
  },
  {
    path: '/reset-password-confirmed',
    component: ResetPasswordConfirmedView,
    meta: {
      layout: AuthLayout,
      requiresAuth: false
    }
  },
  {
    path: '/create-password',
    component: CreatePasswordView,
    meta: {
      layout: AuthLayout,
      requiresAuth: false
    }
  },
  {
    path: '/create-password-confirmed',
    component: CreatePasswordConfirmedView,
    meta: {
      layout: AuthLayout,
      requiresAuth: false
    }
  }
]
